import { TmBaseError } from '@/core/error/tmBaseError'

// error that doesn't have messages and stack
export class TmDummyError extends TmBaseError {
  //
}
